//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DashboardClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type DashboardUpdateDashboardItemSettingsDashboardQueryParameters = {
  id: string ;
}

export type DashboardDeleteItemDashboardQueryParameters = {
  id: string ;
}

export type DashboardGetItemDataDashboardQueryParameters = {
  id: string ;
}

export type DashboardGetCalendarDataDashboardQueryParameters = {
  id: string ;
}

export type DashboardGetAssetListDataDashboardQueryParameters = {
  id: string ;
}

export type DashboardGetNetSavingsDataDashboardQueryParameters = {
  id: string ;
}

export type DashboardGetEventViewDataDashboardQueryParameters = {
  id: string ;
  index: number ;
}

export function dashboardGetUrl(): string {
  let url_ = getBaseUrl() + "/api/dashboard";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let dashboardGetDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfDashboardItemDto, unknown, Types.ListResultDtoOfDashboardItemDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfDashboardItemDto, unknown, Types.ListResultDtoOfDashboardItemDto>, 'queryFn'>> = {
};
export function getDashboardGetDefaultOptions() {
  return dashboardGetDefaultOptions;
};
export function setDashboardGetDefaultOptions(options: typeof dashboardGetDefaultOptions) {
  dashboardGetDefaultOptions = options;
}

export function dashboardGetQueryKey(): QueryKey;
export function dashboardGetQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'DashboardClient',
      'dashboardGet',
    ]);
}
export function __dashboardGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.dashboardGet(
axiosConfig    );
}

/**
 * @return OK
 */
export function useDashboardGetQuery<TSelectData = Types.ListResultDtoOfDashboardItemDto, TError = unknown>(options?: Omit<UseQueryOptions<Types.ListResultDtoOfDashboardItemDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useDashboardGetQuery<TSelectData = Types.ListResultDtoOfDashboardItemDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfDashboardItemDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfDashboardItemDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __dashboardGet(context, axiosConfig) : __dashboardGet,
    queryKey: dashboardGetQueryKey(),
    ...dashboardGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfDashboardItemDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setDashboardGetData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfDashboardItemDto | undefined) => Types.ListResultDtoOfDashboardItemDto, ) {
  queryClient.setQueryData(dashboardGetQueryKey(),
    updater
  );
}

/**
 * @return OK
 */
export function setDashboardGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfDashboardItemDto | undefined) => Types.ListResultDtoOfDashboardItemDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function dashboardAddItemUrl(): string {
  let url_ = getBaseUrl() + "/api/dashboard";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function dashboardAddItemMutationKey(): MutationKey {
  return trimArrayEnd([
      'DashboardClient',
      'dashboardAddItem',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useDashboardAddItemMutation<TContext>(options?: Omit<UseMutationOptions<Types.DashboardItemDto, unknown, Types.DashboardItemCreateDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DashboardItemDto, unknown, Types.DashboardItemCreateDto, TContext> {
  const key = dashboardAddItemMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.DashboardItemCreateDto) => Client.dashboardAddItem(body),
    mutationKey: key,
  });
}
  
export function dashboardUpdateDashboardItemSettingsUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/dashboard/{id}/settings";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function dashboardUpdateDashboardItemSettingsMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'DashboardClient',
      'dashboardUpdateDashboardItemSettings',
      id as any,
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useDashboardUpdateDashboardItemSettingsMutation<TContext>(id: string, options?: Omit<UseMutationOptions<Types.DashboardItemDto, unknown, Types.DashboardItemSettingsDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DashboardItemDto, unknown, Types.DashboardItemSettingsDto, TContext> {
  const key = dashboardUpdateDashboardItemSettingsMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.DashboardItemSettingsDto) => Client.dashboardUpdateDashboardItemSettings(id, body),
    mutationKey: key,
  });
}
  
type DashboardUpdateDashboardItemSettings__MutationParameters = DashboardUpdateDashboardItemSettingsDashboardQueryParameters & {
  body: Types.DashboardItemSettingsDto;
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useDashboardUpdateDashboardItemSettingsMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.DashboardItemDto, unknown, DashboardUpdateDashboardItemSettings__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DashboardUpdateDashboardItemSettingsDashboardQueryParameters}): UseMutationResult<Types.DashboardItemDto, unknown, DashboardUpdateDashboardItemSettings__MutationParameters, TContext> {
  const key = dashboardUpdateDashboardItemSettingsMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DashboardUpdateDashboardItemSettings__MutationParameters) => Client.dashboardUpdateDashboardItemSettings(data.id ?? options?.parameters?.id!, data.body),
  mutationKey: key,
});
}
  
export function dashboardSetDashboardItemOrderUrl(): string {
  let url_ = getBaseUrl() + "/api/dashboard/order";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function dashboardSetDashboardItemOrderMutationKey(): MutationKey {
  return trimArrayEnd([
      'DashboardClient',
      'dashboardSetDashboardItemOrder',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useDashboardSetDashboardItemOrderMutation<TContext>(options?: Omit<UseMutationOptions<Types.ListResultDtoOfDashboardItemDto, unknown, string[], TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ListResultDtoOfDashboardItemDto, unknown, string[], TContext> {
  const key = dashboardSetDashboardItemOrderMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: string[]) => Client.dashboardSetDashboardItemOrder(body),
    mutationKey: key,
  });
}
  
export function dashboardDeleteItemUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/dashboard/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function dashboardDeleteItemMutationKey(id: string): MutationKey {
  return trimArrayEnd([
      'DashboardClient',
      'dashboardDeleteItem',
      id as any,
    ]);
}

/**
 * @return OK
 */
export function useDashboardDeleteItemMutation<TContext>(id: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = dashboardDeleteItemMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.dashboardDeleteItem(id),
    mutationKey: key,
  });
}
  
type DashboardDeleteItem__MutationParameters = DashboardDeleteItemDashboardQueryParameters

/**
 * @return OK
 */
export function useDashboardDeleteItemMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, DashboardDeleteItem__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: DashboardDeleteItemDashboardQueryParameters}): UseMutationResult<void, unknown, DashboardDeleteItem__MutationParameters, TContext> {
  const key = dashboardDeleteItemMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: DashboardDeleteItem__MutationParameters) => Client.dashboardDeleteItem(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function dashboardGetItemDataUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/dashboard/{id}/data";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let dashboardGetItemDataDefaultOptions: Omit<UseQueryOptions<Types.IDashboardData, unknown, Types.IDashboardData>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.IDashboardData, unknown, Types.IDashboardData>, 'queryFn'>> = {
};
export function getDashboardGetItemDataDefaultOptions() {
  return dashboardGetItemDataDefaultOptions;
};
export function setDashboardGetItemDataDefaultOptions(options: typeof dashboardGetItemDataDefaultOptions) {
  dashboardGetItemDataDefaultOptions = options;
}

export function dashboardGetItemDataQueryKey(id: string): QueryKey;
export function dashboardGetItemDataQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as DashboardGetItemDataDashboardQueryParameters;

    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetItemData',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetItemData',
        ...params
      ]);
  }
}
export function __dashboardGetItemData(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.dashboardGetItemData(
      context.queryKey[2] as string,axiosConfig    );
}

export function useDashboardGetItemDataQuery<TSelectData = Types.IDashboardData, TError = unknown>(dto: DashboardGetItemDataDashboardQueryParameters, options?: Omit<UseQueryOptions<Types.IDashboardData, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useDashboardGetItemDataQuery<TSelectData = Types.IDashboardData, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.IDashboardData, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useDashboardGetItemDataQuery<TSelectData = Types.IDashboardData, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.IDashboardData, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as DashboardGetItemDataDashboardQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.IDashboardData, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __dashboardGetItemData(context, axiosConfig) : __dashboardGetItemData,
    queryKey: dashboardGetItemDataQueryKey(id),
    ...dashboardGetItemDataDefaultOptions as unknown as Omit<UseQueryOptions<Types.IDashboardData, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setDashboardGetItemDataData(queryClient: QueryClient, updater: (data: Types.IDashboardData | undefined) => Types.IDashboardData, id: string) {
  queryClient.setQueryData(dashboardGetItemDataQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setDashboardGetItemDataDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.IDashboardData | undefined) => Types.IDashboardData) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function dashboardGetCalendarDataUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/dashboard/{id}/data/calendar";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let dashboardGetCalendarDataDefaultOptions: Omit<UseQueryOptions<Types.CalendarDataDto, unknown, Types.CalendarDataDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CalendarDataDto, unknown, Types.CalendarDataDto>, 'queryFn'>> = {
};
export function getDashboardGetCalendarDataDefaultOptions() {
  return dashboardGetCalendarDataDefaultOptions;
};
export function setDashboardGetCalendarDataDefaultOptions(options: typeof dashboardGetCalendarDataDefaultOptions) {
  dashboardGetCalendarDataDefaultOptions = options;
}

export function dashboardGetCalendarDataQueryKey(id: string): QueryKey;
export function dashboardGetCalendarDataQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as DashboardGetCalendarDataDashboardQueryParameters;

    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetCalendarData',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetCalendarData',
        ...params
      ]);
  }
}
export function __dashboardGetCalendarData(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.dashboardGetCalendarData(
      context.queryKey[2] as string,axiosConfig    );
}

export function useDashboardGetCalendarDataQuery<TSelectData = Types.CalendarDataDto, TError = unknown>(dto: DashboardGetCalendarDataDashboardQueryParameters, options?: Omit<UseQueryOptions<Types.CalendarDataDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useDashboardGetCalendarDataQuery<TSelectData = Types.CalendarDataDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.CalendarDataDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useDashboardGetCalendarDataQuery<TSelectData = Types.CalendarDataDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CalendarDataDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as DashboardGetCalendarDataDashboardQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CalendarDataDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __dashboardGetCalendarData(context, axiosConfig) : __dashboardGetCalendarData,
    queryKey: dashboardGetCalendarDataQueryKey(id),
    ...dashboardGetCalendarDataDefaultOptions as unknown as Omit<UseQueryOptions<Types.CalendarDataDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setDashboardGetCalendarDataData(queryClient: QueryClient, updater: (data: Types.CalendarDataDto | undefined) => Types.CalendarDataDto, id: string) {
  queryClient.setQueryData(dashboardGetCalendarDataQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setDashboardGetCalendarDataDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CalendarDataDto | undefined) => Types.CalendarDataDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function dashboardGetAssetListDataUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/dashboard/{id}/data/asset-list";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let dashboardGetAssetListDataDefaultOptions: Omit<UseQueryOptions<Types.AssetListDataDto, unknown, Types.AssetListDataDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.AssetListDataDto, unknown, Types.AssetListDataDto>, 'queryFn'>> = {
};
export function getDashboardGetAssetListDataDefaultOptions() {
  return dashboardGetAssetListDataDefaultOptions;
};
export function setDashboardGetAssetListDataDefaultOptions(options: typeof dashboardGetAssetListDataDefaultOptions) {
  dashboardGetAssetListDataDefaultOptions = options;
}

export function dashboardGetAssetListDataQueryKey(id: string): QueryKey;
export function dashboardGetAssetListDataQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as DashboardGetAssetListDataDashboardQueryParameters;

    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetAssetListData',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetAssetListData',
        ...params
      ]);
  }
}
export function __dashboardGetAssetListData(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.dashboardGetAssetListData(
      context.queryKey[2] as string,axiosConfig    );
}

export function useDashboardGetAssetListDataQuery<TSelectData = Types.AssetListDataDto, TError = unknown>(dto: DashboardGetAssetListDataDashboardQueryParameters, options?: Omit<UseQueryOptions<Types.AssetListDataDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useDashboardGetAssetListDataQuery<TSelectData = Types.AssetListDataDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.AssetListDataDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useDashboardGetAssetListDataQuery<TSelectData = Types.AssetListDataDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AssetListDataDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as DashboardGetAssetListDataDashboardQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.AssetListDataDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __dashboardGetAssetListData(context, axiosConfig) : __dashboardGetAssetListData,
    queryKey: dashboardGetAssetListDataQueryKey(id),
    ...dashboardGetAssetListDataDefaultOptions as unknown as Omit<UseQueryOptions<Types.AssetListDataDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setDashboardGetAssetListDataData(queryClient: QueryClient, updater: (data: Types.AssetListDataDto | undefined) => Types.AssetListDataDto, id: string) {
  queryClient.setQueryData(dashboardGetAssetListDataQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setDashboardGetAssetListDataDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AssetListDataDto | undefined) => Types.AssetListDataDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function dashboardGetNetSavingsDataUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/dashboard/{id}/data/net-savings";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let dashboardGetNetSavingsDataDefaultOptions: Omit<UseQueryOptions<Types.NetSavingsDataDto, unknown, Types.NetSavingsDataDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.NetSavingsDataDto, unknown, Types.NetSavingsDataDto>, 'queryFn'>> = {
};
export function getDashboardGetNetSavingsDataDefaultOptions() {
  return dashboardGetNetSavingsDataDefaultOptions;
};
export function setDashboardGetNetSavingsDataDefaultOptions(options: typeof dashboardGetNetSavingsDataDefaultOptions) {
  dashboardGetNetSavingsDataDefaultOptions = options;
}

export function dashboardGetNetSavingsDataQueryKey(id: string): QueryKey;
export function dashboardGetNetSavingsDataQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as DashboardGetNetSavingsDataDashboardQueryParameters;

    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetNetSavingsData',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetNetSavingsData',
        ...params
      ]);
  }
}
export function __dashboardGetNetSavingsData(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.dashboardGetNetSavingsData(
      context.queryKey[2] as string,axiosConfig    );
}

export function useDashboardGetNetSavingsDataQuery<TSelectData = Types.NetSavingsDataDto, TError = unknown>(dto: DashboardGetNetSavingsDataDashboardQueryParameters, options?: Omit<UseQueryOptions<Types.NetSavingsDataDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useDashboardGetNetSavingsDataQuery<TSelectData = Types.NetSavingsDataDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.NetSavingsDataDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useDashboardGetNetSavingsDataQuery<TSelectData = Types.NetSavingsDataDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.NetSavingsDataDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as DashboardGetNetSavingsDataDashboardQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.NetSavingsDataDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __dashboardGetNetSavingsData(context, axiosConfig) : __dashboardGetNetSavingsData,
    queryKey: dashboardGetNetSavingsDataQueryKey(id),
    ...dashboardGetNetSavingsDataDefaultOptions as unknown as Omit<UseQueryOptions<Types.NetSavingsDataDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setDashboardGetNetSavingsDataData(queryClient: QueryClient, updater: (data: Types.NetSavingsDataDto | undefined) => Types.NetSavingsDataDto, id: string) {
  queryClient.setQueryData(dashboardGetNetSavingsDataQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setDashboardGetNetSavingsDataDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.NetSavingsDataDto | undefined) => Types.NetSavingsDataDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function dashboardGetEventViewDataUrl(id: string, index: number): string {
  let url_ = getBaseUrl() + "/api/dashboard/{id}/data/event-view/{index}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (index === undefined || index === null)
  throw new Error("The parameter 'index' must be defined.");
url_ = url_.replace("{index}", encodeURIComponent("" + index));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let dashboardGetEventViewDataDefaultOptions: Omit<UseQueryOptions<Types.CalculatedValueResultDto, unknown, Types.CalculatedValueResultDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CalculatedValueResultDto, unknown, Types.CalculatedValueResultDto>, 'queryFn'>> = {
};
export function getDashboardGetEventViewDataDefaultOptions() {
  return dashboardGetEventViewDataDefaultOptions;
};
export function setDashboardGetEventViewDataDefaultOptions(options: typeof dashboardGetEventViewDataDefaultOptions) {
  dashboardGetEventViewDataDefaultOptions = options;
}

export function dashboardGetEventViewDataQueryKey(dto: DashboardGetEventViewDataDashboardQueryParameters): QueryKey;
export function dashboardGetEventViewDataQueryKey(id: string, index: number): QueryKey;
export function dashboardGetEventViewDataQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, index,  } = params[0] as DashboardGetEventViewDataDashboardQueryParameters;

    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetEventViewData',
        id as any,
        index as any,
      ]);
  } else {
    return trimArrayEnd([
        'DashboardClient',
        'dashboardGetEventViewData',
        ...params
      ]);
  }
}
export function __dashboardGetEventViewData(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.dashboardGetEventViewData(
      context.queryKey[2] as string,       context.queryKey[3] as number,axiosConfig    );
}

export function useDashboardGetEventViewDataQuery<TSelectData = Types.CalculatedValueResultDto, TError = unknown>(dto: DashboardGetEventViewDataDashboardQueryParameters, options?: Omit<UseQueryOptions<Types.CalculatedValueResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useDashboardGetEventViewDataQuery<TSelectData = Types.CalculatedValueResultDto, TError = unknown>(id: string, index: number, options?: Omit<UseQueryOptions<Types.CalculatedValueResultDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useDashboardGetEventViewDataQuery<TSelectData = Types.CalculatedValueResultDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CalculatedValueResultDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let index: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, index,  } = params[0] as DashboardGetEventViewDataDashboardQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, index, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CalculatedValueResultDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __dashboardGetEventViewData(context, axiosConfig) : __dashboardGetEventViewData,
    queryKey: dashboardGetEventViewDataQueryKey(id, index),
    ...dashboardGetEventViewDataDefaultOptions as unknown as Omit<UseQueryOptions<Types.CalculatedValueResultDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setDashboardGetEventViewDataData(queryClient: QueryClient, updater: (data: Types.CalculatedValueResultDto | undefined) => Types.CalculatedValueResultDto, id: string, index: number) {
  queryClient.setQueryData(dashboardGetEventViewDataQueryKey(id, index),
    updater
  );
}

/**
 * @return OK
 */
export function setDashboardGetEventViewDataDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CalculatedValueResultDto | undefined) => Types.CalculatedValueResultDto) {
  queryClient.setQueryData(queryKey, updater);
}